import { useContext, useMemo } from 'react';

import {
  PreparedWorkload,
  useWoopWorkloadFilters,
} from 'features/workload-optimization';

import {
  kindCriterion,
  namespaceCriterion,
} from '../../../_workloads-list/searchCriteria';
import {
  configuredViaCriterion,
  horizontalOptimizationCriterion,
  hpaCriterion,
  jvmCriterion,
  makeAccessCriterion,
  optimizedCriterion,
  predictiveCriterion,
  statusCriterion,
  verticalOptimizationCriterion,
  verticalScalingPolicyCriterion,
} from '../../searchCriteria';
import { OptimizationWorkloadsListContext } from '../../context';

import { makeSearchBoxCriteria } from '@cast/shared-search-ui';

const WORKLOAD_TABLE_SEARCH_WORKLOAD_ID_KEY = 'workloadId';
export const WORKLOAD_TABLE_SEARCH_WORKLOAD_NAME_KEY = 'workloadName';

export const useWorkloadsTableCriteria = () => {
  const { data } = useWoopWorkloadFilters();
  const { isNamespaceWritable } = useContext(OptimizationWorkloadsListContext);

  return useMemo(
    () => [
      ...makeSearchBoxCriteria<PreparedWorkload>(
        {
          key: WORKLOAD_TABLE_SEARCH_WORKLOAD_ID_KEY,
          title: 'Workload ID:',
          prop: 'id',
          options: data?.workloadIds ?? [],
          allowMultiple: true,
        },
        {
          key: WORKLOAD_TABLE_SEARCH_WORKLOAD_NAME_KEY,
          title: 'Workload name:',
          prop: 'name',
          options: data?.workloadNames ?? [],
          allowMultiple: true,
          matcher: 'exact',
        }
      ),
      kindCriterion,
      configuredViaCriterion,
      predictiveCriterion,
      namespaceCriterion,
      verticalScalingPolicyCriterion,
      optimizedCriterion,
      hpaCriterion,
      jvmCriterion,
      statusCriterion,
      verticalOptimizationCriterion,
      horizontalOptimizationCriterion,
      makeAccessCriterion(isNamespaceWritable),
    ],
    [data, isNamespaceWritable]
  );
};
